import { useRoutes } from "react-router-dom";
import type { AppRouteProps } from "../../types";
import { renderRoute } from "../../utils/renderRoute";

export const RenderRoutes = ({ routes }: { routes: AppRouteProps[] }) => {
  const reactRoutes = routes.map(renderRoute);
  return useRoutes(reactRoutes);
};
